const headerData = [
    {
      prop: 'id',
      label: '序号',
      columnwidth: 50
    },
    {
      prop: 'StatusName',
      label: '状态',
      columnwidth: 80
    },
    {
      prop: 'cSOCode',
      label: '订单号',
      columnwidth: 150
    },
    {
      prop: 'dDate',
      label: '订货日期',
      columnwidth: 100
    },
    {
      prop: 'SOMonth',
      label: '订单年月',
      columnwidth: 100
    },
    {
      prop: 'dmodifysystime',
      label: '记录更新日期',
      columnwidth: 100
    },
    {
      prop: 'AccId',
      label: '分销商代码',
      columnwidth: 124
    },
    {
      prop: 'AccName',
      label: '分销商名称',
      columnwidth: 130
    },
    {
      prop: 'CusGrade',
      label: '卖方级别',
      columnwidth: 80
    },
    {
      prop: 'cCusName',
      label: '客户名称',
      columnwidth: 134
    },
    {
      prop: 'cCusCode',
      label: '客户编号',
      columnwidth: 150
    },
    {
      prop: 'CusType',
      label: '客户分类',
      columnwidth: 80
    },
    {
      prop: 'VoucherType',
      label: '单据类型',
      columnwidth: 100
    },
    {
      prop: 'cMaker',
      label: '制单人',
      columnwidth: 150
    },
    {
      prop: 'cInvStd',
      label: '产品代码',
      columnwidth: 80
    },
    {
      prop: 'cInvName',
      label: '产品名称',
      columnwidth: 300
    },
    {
      prop: 'Batch',
      label: '批号',
      columnwidth: 100
    },
    {
      prop: 'ValiDate',
      label: '有效期至',
      columnwidth: 100
    },
    {
      prop: 'InvClassName',
      label: '产品线',
      columnwidth: 100
    },
    {
      prop: 'LEVEL1',
      label: 'LEVEL1',
      columnwidth: 100
    },
    {
      prop: 'LEVEL2',
      label: 'LEVEL2',
      columnwidth: 100
    },
    {
      prop: 'LEVEL3',
      label: 'LEVEL3',
      columnwidth: 100
    },
    {
      prop: 'LEVEL4',
      label: 'LEVEL4',
      columnwidth: 100
    },
    {
      prop: 'cComUnitName',
      label: '单位',
      columnwidth: 80
    },
    {
      prop: 'iQuantity',
      label: '订单数量',
      columnwidth: 80
    },
    {
      prop: 'iTaxUnitPrice',
      label: '原币含税单价',
      columnwidth: 100
    },
    {
      prop: 'iSum',
      label: '原币价税合计',
      columnwidth: 100
    },
    {
      prop: 'StandardCost',
      label: '参考价格',
      columnwidth: 80
    },
    {
      prop: 'StandardSum',
      label: '参考价格合计',
      columnwidth: 100
    },
    {
      prop: 'DLDate',
      label: '发货日期',
      columnwidth: 100
    },
    {
      prop: 'RdDate',
      label: '出库日期',
      columnwidth: 100
    },
    {
      prop: 'cSTName',
      label: '销售类型',
      columnwidth: 150
    },
    {
      prop: 'cMemo',
      label: '订单备注',
      columnwidth: 150
    },
    {
      prop: 'cVerifier',
      label: '审核人',
      columnwidth: 174
    },
    {
      prop: 'dcreatesystime',
      label: '创建时间',
      columnwidth: 100
    },
    {
      prop: 'dverifydate',
      label: '审核时间',
      columnwidth: 100
    },
    {
      prop: 'cInvCode',
      label: '产品编码',
      columnwidth: 80
    },
    {
      prop: 'iUnitPrice',
      label: '原币无税单价',
      columnwidth: 100
    },
    {
      prop: 'iTax',
      label: '原币税额',
      columnwidth: 80
    },
    {
      prop: 'iMoney',
      label: '原币金额',
      columnwidth: 80
    },
    {
      prop: 'iNatUnitPrice',
      label: '本币无税单价',
      columnwidth: 100
    },
    {
      prop: 'iNatMoney',
      label: '本币金额',
      columnwidth: 80
    },
    {
      prop: 'iNatSum',
      label: '本币价税合计',
      columnwidth: 100
    },
    {
      prop: 'iNatTax',
      label: '本币税额',
      columnwidth: 80
    },
    {
      prop: 'iFHQuantity',
      label: '发货数量',
      columnwidth: 80
    },
    {
      prop: 'iFHMoney',
      label: '发货金额',
      columnwidth: 80
    },
    {
      prop: 'fOutQuantity',
      label: '出库数量',
      columnwidth: 80
    },
    {
      prop: 'fRetQuantity',
      label: '退货数量',
      columnwidth: 80
    },
    {
      prop: 'iKPQuantity',
      label: '开票数量',
      columnwidth: 80
    },
    {
      prop: 'iKPMoney',
      label: '开票金额',
      columnwidth: 80
    },
    {
      prop: 'cexch_name',
      label: '币种',
      columnwidth: 80
    },
    {
      prop: 'iExchRate',
      label: '汇率',
      columnwidth: 50
    },
    {
      prop: 'iTaxRate',
      label: '税率',
      columnwidth: 50
    }
  ]
 export default headerData;